import { Ref } from 'react';
import { useTranslation } from 'react-i18next';
import {
  forwardRef,
  ModalHeader as ChakraModalHeader,
  ModalHeaderProps as ChakraModalHeaderProps,
  Flex,
  HeadingProps,
  Heading,
  ModalCloseButton,
} from '@chakra-ui/react';

import { LeadPhoto } from '@backend/src/frontend-mongo-interfaces/mongoose.gen';

export type ModalHeaderProps = {
  children?: ChakraModalHeaderProps['children'];
  title?: HeadingProps['children'];
  photo?: LeadPhoto;
  closeButton?: ChakraModalHeaderProps['children'];
  ref?: Ref<HTMLElement> | undefined;
} & Omit<ChakraModalHeaderProps, 'title'>;

const ModalHeader = forwardRef<ModalHeaderProps, 'div'>(
  ({ children, title, closeButton: incomingCloseButton, ...rest }, ref) => {
    const { t } = useTranslation();

    const closeButton = incomingCloseButton || (
      <ModalCloseButton aria-label={t('Close')} />
    );
    return (
      <ChakraModalHeader
        ref={ref}
        fontSize="lg"
        fontWeight="bold"
        as={Flex}
        pr={10}
        textAlign={'center'}
        {...rest}
      >
        {closeButton}
        {title && (
          <Heading fontSize="2xl" w="100%">
            {title}
          </Heading>
        )}
        {children}
      </ChakraModalHeader>
    );
  },
);

export default ModalHeader;
